//import '@vg-constellation/web/youtube-player'

import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core'
import { AdobeLaunchService } from 'src/server/adobe-launch/adobe-launch.service'

const TWENTY_FIVE_PERCENT = 25
const FIFTY_PERCENT = 50
const SEVENTY_FIVE_PERCENT = 75
const ONE_HUNDRED = 100
const VIDEO_START = 300
@Component({
  selector: 'vmf-constellation-video',
  templateUrl: './constellation-video.component.html',
  styleUrls: ['./constellation-video.component.scss'],
  providers: [],
})
export class ConstellationVideoComponent implements AfterViewInit {
  @Input() youtubeId: string

  //@ViewChild('c11nVideo', { static: false }) videoComponent: VideoComponent
  @ViewChild('simpleDialogContent', { static: false })
  simpleDialogContent: TemplateRef<any>
  dialogTitle: string
  dialogBody: string
  YTPlayer: any
  @ViewChild('videoContainer', { read: ElementRef })
  videoContainerRef: ElementRef = {} as ElementRef

  mediaEvents = {
    playedFromStart: false,
    playedToPosition25: false,
    playedToPosition50: false,
    playedToPosition75: false,
  }
  lastPosition: any = 0
  checkCookie: boolean

  constructor(
    public readonly viewContainer: ViewContainerRef,
    public adobeLaunchService: AdobeLaunchService,
  ) {}

  ngOnInit() {
    this.checkCookie = this.getThirdPartyConsent()
  }

  fundVideoList = {
    IKz6h56DU7I: {
      title: 'Wellington Management Company',
      description:
        "Wellington Management Company CEO Jean Hynes describes how the firm's collaborative culture, private ownership model and global investment resources help set it apart.",
      transcriptTitle: '<span>Wellington Management Company</span>',
      transcriptBody:
        "<span>Wellington has three unique edges that I think help us really serve the Vanguard owners over long periods of time. One would be our culture, the sharing that goes on, the debate that goes on about important topics of innovation, about geopolitics, about what's happening in the world. We all benefit from that ecosystem and that took really decades to build.</span><br><br><span>Culture has been really important since the first day I arrived at Wellington.  And that's about a series of shared values, being very client focused, being very humble, being very focused on excellence.   Those are just to name a few. Second is our ownership model. We're a private partnership and the most interesting thing about the private partnership is that it formed in 1979.  And now it has scaled our size, it's scaled geography and it's also scaled successions. And then finally, I'll talk about our investment ecosystem. We have broad capabilities across equities, fixed income, hedge funds, and the most important part of that is that it's one ecosystem. It's not siloed across asset classes, it's not siloed across geographies.</span><br><br><span>Wellington and Vanguard have a very unique partnership that really goes back to the founding of both companies.  The most interesting thing about the relationship is how we use each other's strengths. So Wellington really focuses on investment content. How do we create equity products, fixed income products for example? And my goal as CEO is to continue to strengthen the relationship between the senior leadership at Vanguard, the portfolio managers and so that we can be successful with Vanguard and Vanguard owners for the next 100 years.</span>",
      duration: '2:00',
      image:
        'https://corporate.vanguard.com/content/dam/corp/articles/images/jean_hynes_video_still.jpg',
    },
    'D_x-o8LuoOY': {
      title: 'Hear from Vanguard and Wellington leaders',
      description:
        'Watch Vanguard President and CIO Greg Davis and Wellington CEO Jean Hynes as they discuss the new ETFs and the strength of our enduring partnership.',
      transcriptTitle: '<span>Hear from Vanguard and Wellington leaders</span>',
      transcriptBody:
        "<span>For more than 50 years, Vanguard and Wellington have partnered to deliver actively managed funds. The two firms are grounded in a shared mission to help people achieve their financial goals, whether that's planning for retirement, purchasing a home or building long-term financial security. We're committed to supporting both investors and the advisors who serve them.</span><br><br><span>We're excited to build on our collaboration with Vanguard to deliver a broader range of solutions that meet investors evolving needs. With a century of experience and active management. We're pleased to provide proven strategies and a low cost, tax-efficient ETF wrapper.</span><br><br><span>The new ETFs bring together the best of both firms. Vanguard's ETF expertise and a legacy of providing industry leading investment products and Wellington's expertise in active management. It's our first time teaming up with Wellington on ETFs, and it's the first time we've offered fundamental active equity strategies in an ETF. Each ETF can play a clear and distinct role within a portfolio while also complementing one another.</span><br><br><span>The new Vanguard Wellington ETFs feature distinct equity approaches including value, growth, and dividend growth. These high conviction active strategies are led by seasoned Wellington portfolio managers with strong long-term track records. The managers are supported by the breadth and depth of Wellington's global research platform.</span><br><br><span>Together we've shown that active management centered on talent, discipline, and low cost can deliver real value for investors over the long term.</span><br><br><span>The Vanguard Wellington ETFs offer a new way to access time tested active equity strategies.</span>",
      duration: '2:03',
      image:
        'https://digital-assets.vanguard.com/retail/digital/en/photos/vg-greg-davis-and-jean-hynes-video.jpg',
    },
  }

  async ngAfterViewInit() {
    const c11nYTPlayerElementLoaded: any = {}
    c11nYTPlayerElementLoaded.promise = new Promise((resolve, reject) => {
      c11nYTPlayerElementLoaded.resolve = resolve
      c11nYTPlayerElementLoaded.reject = reject
    })

    if (
      this.videoContainerRef.nativeElement.hasAttribute(
        'c11n-web-youtube-player',
      )
    ) {
      c11nYTPlayerElementLoaded.resolve()
    } else {
      const observer = new MutationObserver(() => {
        if (
          this.videoContainerRef.nativeElement.hasAttribute(
            'c11n-web-youtube-player',
          )
        ) {
          c11nYTPlayerElementLoaded.resolve()
          observer.disconnect()
        }
      })
      observer.observe(this.videoContainerRef.nativeElement, {
        attributes: true,
      })
    }

    // wait until the c11n-web-b5-youtube-player bootstraps
    await c11nYTPlayerElementLoaded.promise
    this.videoContainerRef.nativeElement.onReady = (evt: any) => {
      this.YTPlayer = this.videoContainerRef.nativeElement.player
      this.YTPlayer.playVideo()
    }
  }

  // ngAfterViewInit() {
  //   console.log('After view init')
  //   // eslint-disable-next-line complexity, max-statements
  //   // this.videoComponent.playerEvents.asObservable().subscribe((event) => {
  //   //   const percentageComplete = Math.round(
  //   //     (event.data.positionInMilliseconds /
  //   //       event.data.durationInMilliseconds) *
  //   //       ONE_HUNDRED,
  //   //   )
  //   //   switch (event.event) {
  //   //     case 'onPlayheadUpdate':
  //   //       this.lastPosition = event.data.positionInMilliseconds
  //   //       if (
  //   //         event.data.positionInMilliseconds < VIDEO_START &&
  //   //         percentageComplete < TWENTY_FIVE_PERCENT &&
  //   //         !this.mediaEvents['playedFromStart']
  //   //       ) {
  //   //         this.mediaEvents['playedFromStart'] = true
  //   //         this.adobeLaunchService.mediaEvent('mediaPlay', this.limelightId)
  //   //       } else if (
  //   //         percentageComplete >= TWENTY_FIVE_PERCENT &&
  //   //         !this.mediaEvents['playedToPosition25']
  //   //       ) {
  //   //         this.mediaEvents['playedToPosition25'] = true
  //   //         this.adobeLaunchService.mediaEvent(
  //   //           'media25PercentPlayed',
  //   //           this.limelightId,
  //   //         )
  //   //       } else if (
  //   //         percentageComplete >= FIFTY_PERCENT &&
  //   //         !this.mediaEvents['playedToPosition50']
  //   //       ) {
  //   //         this.mediaEvents['playedToPosition50'] = true
  //   //         this.adobeLaunchService.mediaEvent(
  //   //           'media50PercentPlayed',
  //   //           this.limelightId,
  //   //         )
  //   //       } else if (
  //   //         percentageComplete >= SEVENTY_FIVE_PERCENT &&
  //   //         !this.mediaEvents['playedToPosition75']
  //   //       ) {
  //   //         this.mediaEvents['playedToPosition75'] = true
  //   //         this.adobeLaunchService.mediaEvent(
  //   //           'media75PercentPlayed',
  //   //           this.limelightId,
  //   //         )
  //   //       }
  //   //       break
  //   //     case 'onMediaComplete':
  //   //       this.adobeLaunchService.mediaEvent('mediaComplete', this.limelightId)
  //   //       this.mediaEvents['playedFromStart'] = false
  //   //       this.mediaEvents['playedToPosition25'] = false
  //   //       this.mediaEvents['playedToPosition50'] = false
  //   //       this.mediaEvents['playedToPosition75'] = false
  //   //       break
  //   //   }
  //   // })
  // }

  setDialogInfo(dialogTitle: string) {
    this.dialogTitle = dialogTitle
    this.dialogBody =
      this.dialogTitle === 'Investing in the future of health care' ||
      this.dialogTitle === 'Wellington Management Company'
        ? this.fundVideoList[this.youtubeId].transcriptBody
        : ''

    this.adobeLaunchService.callToAction(
      'Open',
      'Video Transcript Modal',
      'Info',
    )
  }

  addInPlayVideo() {
    this.checkCookie = true
    this.videoContainerRef.nativeElement.displayVideo()
  }

  getThirdPartyConsent(): boolean {
    const optanonCookie = document.cookie
      .split(';')
      .find((cookie) => cookie.trim().startsWith('OptanonConsent='))
    if (optanonCookie) {
      const groupsValues = optanonCookie
        .split('&')
        .find((cookie) => cookie.includes('groups'))
        ?.split('=')[1]
      if (groupsValues) {
        const thirdPartyGroupsConsentValue = decodeURIComponent(groupsValues)
          .split(',')
          .find((key) => key.includes('C0004'))
          ?.split(':')[1]

        const hasConsent = thirdPartyGroupsConsentValue === '1'
        return hasConsent
      }
    }
    return false
  }
}
